/** WhatsApp channel title: the phone's provider display name, otherwise the platform label. */
export function whatsAppProviderTitle(
  displayName: string | null | undefined,
  platformLabel: string,
): string {
  const name = typeof displayName === "string" ? displayName.trim() : "";
  return name.length > 0 ? name : platformLabel;
}
